<mat-card class="card">
  <mat-card-header>
    <h3 mat-card-title>
      {{ 'Topology' | translate }}
      <ix-pool-card-icon [type]="iconType" [tooltip]="iconTooltip"></ix-pool-card-icon>
    </h3>

    <button
      mat-button
      ixTest="manage-devices"
      (click)="router.navigate(['/storage', this.poolState.id, 'devices'])"
    >
      {{ 'Manage Devices' | translate }}
    </button>
  </mat-card-header>

  <mat-card-content fxFlex="100">
    <div class="content-container">
      <div class="vdev-line">
        <b>{{ 'Data VDEVs' | translate }}</b>
        <div class="vdev-stats">
          <span
            *ngIf="!!topologyWarningsState.data && !isPoolOffline"
            class="warning"
            [matTooltip]="topologyWarningsState.data"
          >
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span *ngIf="!isPoolOffline" class="vdev-value">{{ topologyState.data }}</span>
          <span
            *ngIf="isPoolOffline"
            class="warning"
          >
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span *ngIf="isPoolOffline" class="offline-data-vdevs">{{ 'Offline VDEVs' | translate }}</span>
        </div>
      </div>
      <div class="vdev-line">
        <b>{{ 'Metadata VDEVs' | translate }}</b>
        <div *ngIf="!isPoolOffline; else notAvailable" class="vdev-stats">
          <span *ngIf="!!topologyWarningsState.metadata" class="warning" [matTooltip]="topologyWarningsState.metadata">
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span class="vdev-value">{{ topologyState.metadata }}</span>
        </div>
      </div>
      <div class="vdev-line">
        <b>{{ 'Log VDEVs' | translate }}</b>
        <div *ngIf="!isPoolOffline; else notAvailable" class="vdev-stats">
          <span *ngIf="!!topologyWarningsState.log" class="warning" [matTooltip]="topologyWarningsState.log">
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span class="vdev-value">{{ topologyState.log }}</span>
        </div>
      </div>
      <div class="vdev-line">
        <b>{{ 'Cache VDEVs' | translate }}</b>
        <div *ngIf="!isPoolOffline; else notAvailable" class="vdev-stats">
          <span *ngIf="!!topologyWarningsState.cache" class="warning" [matTooltip]="topologyWarningsState.cache">
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span class="vdev-value">{{ topologyState.cache }}</span>
        </div>
      </div>
      <div *ngIf="!isDraidLayoutDataVdevs" class="vdev-line">
        <b>{{ 'Spare VDEVs' | translate }}</b>
        <div *ngIf="!isPoolOffline; else notAvailable" class="vdev-stats">
          <span *ngIf="!!topologyWarningsState.spare" class="warning" [matTooltip]="topologyWarningsState.spare">
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span class="vdev-value">{{ topologyState.spare }}</span>
        </div>
      </div>
      <div class="vdev-line">
        <b>{{ 'Dedup VDEVs' | translate }}</b>
        <div *ngIf="!isPoolOffline; else notAvailable" class="vdev-stats">
          <span *ngIf="!!topologyWarningsState.dedup" class="warning" [matTooltip]="topologyWarningsState.dedup">
            <ix-icon name="error" class="pool-icon icon-warning"></ix-icon>
          </span>
          <span class="vdev-value">{{ topologyState.dedup }}</span>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<ng-template #notAvailable><span class="vdev-value">{{ 'N/A' | translate }}</span></ng-template>